import AdminNotification from './admin_notification';
import AutoAcceptedSessionNotification from './auto_accepted_session_notification';
import ConversationNotification from './conversation_notification';
import DeclinedReassignedSessionNotification from './declined_reassigned_session_notification';
import DisconnectNotification from './disconnect_notification';
import ErrorNotification from './error_notification';
import NotificationType from './notification_type';
import OfferedCallNotification from './offered_call_notification';
import OfferedWarmTransferNotification from './offered_warm_transfer_notification';
import OptionalReloadNotification from './optional_reload_notification';
import OptionalUpgradeNotification from './optional_upgrade_notification';
import IncomingConcurrentMessageNotification from 'models/notification/incoming_concurrent_message_notification';
import IncomingConcurrentSessionNotification from 'models/notification/incoming_concurrent_session_notification';
import SuccessNotification from 'models/notification/success_notification';
import TaskNotification from './task_notification';
import UnofferedCallNotification from './unoffered_call_notification';
import UnofferedWarmTransferNotification from './unoffered_warm_transfer_notification';

export default [
  [NotificationType.ADMIN, AdminNotification],
  [NotificationType.ASSIGNED_CONVERSATION, ConversationNotification],
  [NotificationType.ASSIGNED_TASK, TaskNotification],
  [NotificationType.AUTO_ACCEPTED_SESSION_NOTIFICATION, AutoAcceptedSessionNotification],
  [NotificationType.DISCONNECT, DisconnectNotification],
  [NotificationType.DECLINED_REASSIGNED_SESSION, DeclinedReassignedSessionNotification],
  [NotificationType.ERROR, ErrorNotification],
  [NotificationType.INCOMING_CONCURRENT_MESSAGE, IncomingConcurrentMessageNotification],
  [NotificationType.INCOMING_CONCURRENT_SESSION, IncomingConcurrentSessionNotification],
  [NotificationType.OFFERED_CALL, OfferedCallNotification],
  [NotificationType.OFFERED_WARM_TRANSFER, OfferedWarmTransferNotification],
  [NotificationType.OPTIONAL_RELOAD, OptionalReloadNotification],
  [NotificationType.OPTIONAL_UPGRADE, OptionalUpgradeNotification],
  [NotificationType.SUCCESS, SuccessNotification],
  [NotificationType.UNOFFERED_CALL, UnofferedCallNotification],
  [NotificationType.UNOFFERED_WARM_TRANSFER, UnofferedWarmTransferNotification],
];



// WEBPACK FOOTER //
// ./src/scripts/domain/models/notification/notification_classes.js